import styled from 'styled-components/macro';

import {
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Stack
} from "@chakra-ui/react";
import {useFeedback} from "../../store/feedback";
import {useAddNote, useNotes} from "../../api/moderation";
import {useModal, useRelativeTimeFormatter} from "../../store";
// eslint-disable-next-line import/no-cycle
import AddNote from "./add_note";

const Item = styled.div`
  margin-top: 12px;
  width: 100%;

  svg {
    margin-right: 16px;
    font-size: 26px;
  }

  &:first-of-type {
    margin-top: 0;
  }`;
const Scroll = styled.div`
  max-height: 286px;
  overflow-y: auto;`;
const Author = styled.div`
  font-weight: 500;`;
const Ago = styled.div`
  margin-left: auto;
  font-size: 14px;
  color: ${({theme}) => theme.placeholder_gray_2};`;
const Details = styled.div`
  display: flex;
  margin-bottom: 4px;`;

const Notes = styled(({post, comment, onClose}) => {
    const modal = useModal();
    const {feedbackCh} = useFeedback();
    const author = post ? post.author : comment.author;
    const community = post ? post.community : comment.community;
    const notes = useNotes(feedbackCh, author, community);
    const addNote = useAddNote(feedbackCh);
    const formatRelativeTime = useRelativeTimeFormatter();
    const handleNewNote = () => {
        modal.open(AddNote, {post, comment});
    };
    return (
        <Modal
            isOpen
            onClose={onClose}
            size={'lg'}
        >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Notes on /u/{author}</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6}>
                    <Stack spacing={'5'}>

                        {notes?.length == 0 && <span>No notes yet.</span>}

                        <Scroll>
                            {notes?.map((note) => (
                                <Item key={note.id}>
                                    <Details>
                                        <Author>{note.author}</Author>
                                        <Ago>{formatRelativeTime(note.created)}</Ago>
                                    </Details>
                                    <p>{note.note}</p>
                                </Item>
                            ))}
                        </Scroll>

                    </Stack>
                </ModalBody>
                <ModalFooter>
                    <Button variant="cancel" mr={3} onClick={onClose}>Cancel</Button>
                    <Button variant="blue" onClick={handleNewNote}>Add</Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )})``;

export default Notes;
